// extracted by mini-css-extract-plugin
module.exports = {"request":"style_request__1xg6j","title":"style_title__1ppoD","block":"style_block__2culm","inner":"style_inner__13p4z"};